module.exports = "/assets/hero-carrot.png?vOD4snV";